const faqData = [
  {
    question: "What do you specialize in?",
    answer: (
      <>
        Although our clinic confidently treats a wide variety of orthopedic
        conditions, we specialize in working with active individuals —
        especially Crossfit athletes and weightlifters. Our team shares a deep
        connection to movement and performance; we understand
        the demands these sports place on the body — not just clinically, but
        personally.
        <br></br>
        <br></br>
        As a physical therapist and massage therapist team, we combine movement
        analysis, hands-on treatment, and recovery-focused bodywork to help
        clients stay resilient, perform at a high level, and recover efficiently
        between training sessions. Living and working in Colorado gives us
        direct access to the same environments our clients train in, allowing us
        to better understand the intensity, drive, and lifestyle behind their
        goals. We believe effective care comes from both expertise and lived
        experience. That connection allows us to better support athletes in
        every phase of training and recovery.
      </>
    ),
  },
  {
    question: `Do you take my insurance?`,
    answer: ` Concierge Wellness operates as an out of network provider with a fee-for-service business model. 
    This allows us to provide the highest quality of care without the restrictions of insurance companies. 
    We value our transparency with cost and our full attention during your sessions. There are many barriers that 
    insurance sets on providers and we chose to step away from the red tape so we can help you how we see fit. 
    We accept cash, check, Venmo, Cashapp, Zelle, debit/credit cards, and FSA/HSA. 
    We can also provide you with a superbill to submit to your insurance for possible reimbursement.`,
  },
  {
    question: `What is dry needling?`,
    answer: `Dry needling is a therapeutic 
    technique that involves the insertion of thin, solid needles into specific points in the body, known as myofascial trigger 
    points to stimulate a healing response. Unlike acupuncture, which is rooted in traditional Chinese medicine and focuses 
    on balancing the body's energy flow, dry needling is a Western medicine technique primarily used to improve tissue health, 
    decrease pain, and improve muscle function.`,
  },
  {
    question: `Can you work with clients in another state?`,
    answer: `YES! Currently licensed in CO, TX, WA, NH, AZ and offer virtual appointments at your own convenience.`,
  },
  {
    question: `Do I need a referral from my Doctor?`,
    answer: `This will depend on your state but Colorado has direct access meaning you do NOT need a referral 
    to see a Doctor of Physical Therapy. If you have questions about your specific state just contact us and 
    we’d be happy to help.`,
  },
];

export default faqData;
